import React, { useMemo, useCallback, useEffect } from 'react';
import { testId } from '../../../../utils/testIds';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { DEFAULT_COUNTRY_CODE, FALLBACK_COUNTRIES } from '../../constants';
import { getSectionFromKey } from '../utils/addressLabels';
import { useAddressSiblings } from '../utils/addressKeys';
import { useCountries } from '../../../../containers/CreationForms/AddEditWorkkard/hooks/useCountries';
import { useStates } from '../../../../containers/CreationForms/AddEditWorkkard/hooks/useStates';
import { clearTimezone } from '../../../../containers/CreationForms/AddEditWorkkard/store/timezoneSlice';
import { fetchCountriesRequest } from '../../../../containers/CreationForms/AddEditWorkkard/store/addressSlice';

function CountrySelectField({ config, value, onChange, onBlur, disabled, required, error }) {
  const { setValue } = useFormContext();
  const dispatch = useDispatch();

  const section = useMemo(() => getSectionFromKey(config.fieldKey), [config.fieldKey]);

  const { zipKey, stateKey, countyKey, cityKey } = useAddressSiblings(config.fieldKey);

  const { countries, loading } = useCountries(section);

  useEffect(() => {
    if (section !== 'mailing') return;
    dispatch(fetchCountriesRequest({ section }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentValue = value || DEFAULT_COUNTRY_CODE;

  useStates(section, currentValue);

  const options = countries.length > 0 ? countries : FALLBACK_COUNTRIES;

  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    onChange(newValue);

    [zipKey, stateKey, countyKey, cityKey].forEach((k) => {
      if (k) setValue(k, '', { shouldDirty: true, shouldValidate: false });
    });

    if (section === 'property') {
      dispatch(clearTimezone());
    }
  }, [onChange, setValue, zipKey, stateKey, countyKey, cityKey, section, dispatch]);

  return (
    <select
      data-test={testId('field', config.fieldKey, 'input')}
      className={`field-engine-select field-engine-select--country${error ? ' field-engine-select--error' : ''}${loading ? ' field-engine-select--loading' : ''}${disabled ? ' disabled' : ''}`}
      value={currentValue}
      onChange={handleChange}
      onBlur={onBlur}
      disabled={disabled || loading}
      required={required}
      aria-label="Country"
    >
      {options.map((c) => (
        <option key={c.value} value={c.value}>{c.label}</option>
      ))}
    </select>
  );
}

export default CountrySelectField;
